import { Component, OnInit, ChangeDetectionStrategy, ViewEncapsulation, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-pillbox',
  templateUrl: './pillbox.component.html',
  styleUrls: ['./pillbox.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None
})
export class PillboxComponent implements OnInit {
  @Input()
  canExit = false;

  @Input()
  padding: 'none' | 'dense' | 'normal' = 'normal';

  @Input()
  orientation: 'horizontal' | 'vertical' = 'horizontal';

  @Input()
  name = '';

  // Used for Google Analytics event tracking
  // See: https://www.notion.so/biodigital/Human-Web-Google-Analytics-Events-d685075c60b84e0fbca3c2139775608b
  @Input()
  eventCategory = '';

  @Output()
  exit = new EventEmitter();

  constructor() { }

  ngOnInit() {
  }

  handleExitClick() {
    this.exit.emit();
  }

}
